import script from "./Features.vue?vue&type=script&setup=true&lang=ts"
export * from "./Features.vue?vue&type=script&setup=true&lang=ts"

import "./Features.vue?vue&type=style&index=0&id=4d1b6466&scoped=true&lang=scss"

import exportComponent from "/home/temp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1b6466"]])

export default __exports__